var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 302,
    viewBox: "0 0 273 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.038,
    cy: 127.106,
    r: 174.796,
    fill: "url(#paint0_linear_96_4585)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.756 186.524H116.235C115.019 186.524 113.852 186.041 112.992 185.18C112.132 184.32 111.648 183.153 111.648 181.937V156.316C111.648 155.714 111.767 155.117 111.998 154.561C112.228 154.004 112.566 153.499 112.992 153.073L181.794 84.2712C182.654 83.411 183.82 82.9277 185.037 82.9277C186.253 82.9277 187.42 83.411 188.28 84.2712L213.901 109.892C214.761 110.752 215.244 111.919 215.244 113.135C215.244 114.352 214.761 115.518 213.901 116.379L143.756 186.524Z",
    stroke: "#F7F7F7",
    strokeWidth: 9.17356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.689 99.375L198.796 131.482",
    stroke: "#F7F7F7",
    strokeWidth: 9.17356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.557 186.524H143.756L111.94 154.708",
    stroke: "#F7F7F7",
    strokeWidth: 9.17356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_4585",
    x1: 71.1989,
    y1: -47.6895,
    x2: 273.685,
    y2: 279.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47F5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028E7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpLogo);
export default __webpack_public_path__ + "static/media/sign-up-logo.4fa21b3470e5194c6b09c2aa8c6fd322.svg";
export { ForwardRef as ReactComponent };